const HEIF_CONTENT_TYPES = new Set([
  'image/heic',
  'image/heic-sequence',
  'image/heif',
  'image/heif-sequence',
]);

const HEIF_BRANDS = new Set([
  'heic', 'heix', 'hevc', 'hevx', 'heim', 'heis', 'hevm', 'hevs', 'mif1', 'msf1',
]);

export function isHeifAttachment(contentType?: string, filename?: string): boolean {
  const normalizedType = contentType?.trim().toLocaleLowerCase() ?? '';
  const normalizedFilename = filename?.trim().toLocaleLowerCase() ?? '';
  return HEIF_CONTENT_TYPES.has(normalizedType) || normalizedFilename.endsWith('.heic') || normalizedFilename.endsWith('.heif');
}

async function hasHeifSignature(blob: Blob): Promise<boolean> {
  if (blob.size < 12) return false;
  const header = new Uint8Array(await blob.slice(4, Math.min(blob.size, 64)).arrayBuffer());
  if (String.fromCharCode(...header.slice(0, 4)) !== 'ftyp') return false;
  for (let offset = 4; offset + 4 <= header.length; offset += 4) {
    if (HEIF_BRANDS.has(String.fromCharCode(...header.slice(offset, offset + 4)))) return true;
  }
  return false;
}

export async function attachmentPreviewBlob(parts: BlobPart[], contentType?: string, filename?: string): Promise<Blob> {
  const source = new Blob(parts, { type: contentType || 'application/octet-stream' });
  if (!isHeifAttachment(contentType, filename) && !await hasHeifSignature(source)) return source;

  return new Promise((resolve) => {
    const worker = new Worker(new URL('./heicPreview.worker.ts', import.meta.url), { type: 'module', name: 'holdthat-heic-preview' });
    const finish = (value: Blob) => { worker.terminate(); resolve(value); };
    worker.onmessage = (event: MessageEvent<{ blob?: Blob }>) => finish(event.data.blob ?? source);
    worker.onerror = () => finish(source);
    void source.arrayBuffer().then((buffer) => worker.postMessage({ buffer }, [buffer])).catch(() => finish(source));
  });
}
